import { render, staticRenderFns } from "./UserPaymentsHistory.vue?vue&type=template&id=93ff4160&scoped=true&"
import script from "./UserPaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./UserPaymentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ff4160",
  null
  
)

export default component.exports